import { graphql } from "gatsby"
import { EventInfo } from "components/organisms/webinar/EventInfo"
import { formatWebinars } from "utils/prismic"
import get from "lodash.get"
import SEO from "components/seo"
import SectionContainer from "components/molecules/common/SectionContainer"

const Live = ({ data, pageContext: { currentPage } }) => {
  const webinars = formatWebinars(get(data, "allPrismicWebinar", []))
  const webinar = webinars?.[0]
  if (webinar) {
    webinar.sections = webinar?.sections.slice(0, 2)
  }
  return (
    <>
      <SEO title={webinar?.title} />
      <div className="relative overflow-hidden bg-white">
        <div className="relative pb-16 pt-6 sm:pb-24 lg:pb-28">
          <main className="mx-auto mt-20 max-w-7xl space-y-8 px-4 sm:mt-24 sm:px-6 lg:mt-32">
            <div className="max-w-4xl text-left">
              <h1 className="m-0 p-0 text-3xl font-bold tracking-tight text-zinc-900 sm:text-5xl">
                {webinar?.title}
              </h1>
            </div>
            <div className="space-y-8 md:grid md:grid-cols-11 md:gap-8 md:space-y-0">
              <div className="relative mt-12 sm:mx-auto md:col-span-8 md:mx-0 md:mt-0 md:flex md:flex-col md:items-center">
                <iframe
                  src="https://youtube.com/embed/RYK09tN_k8w"
                  title="Live"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="relative mx-auto mb-0 aspect-video w-full"
                />
              </div>
              <div className="relative sm:mx-auto sm:max-w-screen-md md:col-span-3 md:mx-0 md:mt-0 md:flex md:max-w-none md:flex-col md:items-center">
                <iframe
                  src={`https://www.youtube.com/live_chat?v=RYK09tN_k8w&embed_domain=www.${process.env.GATSBY_TARGET_BUCKET}`}
                  title="Live chat"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="relative mx-auto mb-0 w-full md:h-full"
                />
              </div>
            </div>
            <div
              className="rounded-lg bg-zinc-800 p-12 md:grid md:grid-cols-11 md:gap-8"
              id="info"
            >
              <div className="md:col-span-8">
                <EventInfo webinar={webinar} />
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  )
}

export default Live

export const pageQuery = graphql`
  query ($locale: String!, $currentPage: String!) {
    allPrismicWebinar(
      sort: { data: { index: ASC } }
      filter: {
        lang: { eq: $locale }
        data: {
          audience: { eq: "general" }
          show_on_pages: { elemMatch: { page: { eq: $currentPage } } }
        }
      }
    ) {
      nodes {
        id
        lang
        data {
          attendance_type
          language
          show_live_link
          audience
          time
          end
          tag {
            text
          }
          speakers {
            name
            photo {
              gatsbyImageData(width: 200, placeholder: NONE)
              alt
            }
            speaker_description {
              richText
            }
            speaker_subject {
              richText
            }
          }
          duration
          sections {
            description {
              richText
            }
          }
          summary {
            richText
          }
          title {
            text
          }
          highlights {
            text
          }
        }
      }
    }
  }
`
